import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import InfoDashboardTitle from "./components/Title"
import InfoDashboardDescription from "./components/Description"
import InfoDashboardItem from "./components/Item"

const InfoDashboard = ({ children, className }) => {
  return (
    <div className={["info-dashboard", className].join(" ")}>
      <ul>{children}</ul>
    </div>
  )
}

InfoDashboard.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string
}

InfoDashboard.defaultProps = {
  className: ""
}

export { InfoDashboardTitle, InfoDashboardDescription, InfoDashboardItem }

export default InfoDashboard
